/**
 * Formats a decimal number using Turkish locale (comma decimal separator).
 * Returns "-" for null/undefined values. Does not treat 0 as a null value.
 */
export const formatDecimalTr = (value: number | null | undefined, decimals = 2): string => {
  if (value == null) return "-";
  return value.toLocaleString("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

/**
 * Formats a decimal number as a percentage string using Turkish locale
 * (comma decimal separator), e.g. "12,34%". Returns "-" for null/undefined values.
 */
export const formatPercentTr = (value: number | null | undefined, decimals = 2): string => {
  if (value == null) return "-";
  return `${formatDecimalTr(value, decimals)}%`;
};
